import React, { useContext, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Button } from 'ui-components/components/button';
import PropTypes from 'prop-types';
import Global from '../../../../store/global-selectors';
import messages from '../messages';
import { PresetGroupsContext } from '../context';

const NameColumn = ({ id: presetGroupId }) => {
  const name = useSelector((state) =>
    Global.selectEntitiesPresetGroupPropertyById(state, {
      profileId: presetGroupId,
      property: 'name',
    }),
  );
  const { setIsModalOpen, setSelectedPresetId } = useContext(PresetGroupsContext);
  const openModal = useCallback(() => {
    setIsModalOpen(true);
    setSelectedPresetId(presetGroupId);
  }, [presetGroupId, setIsModalOpen, setSelectedPresetId]);
  return (
    <Button onClick={openModal} theme='link'>
      {name}
    </Button>
  );
};

NameColumn.propTypes = {
  id: PropTypes.string.isRequired,
};

export default {
  getMessageDescriptor: messages.nameColumn,
  name: <FormattedMessage {...messages.nameColumn} />,
  id: 'name',
  sortBy: 'name',
  isSortable: true,
  render: NameColumn,
};
